<template>
  <transition name="fade">
    <div class="project" :style="{transform:is_ie}" v-drag>
      <div role="document">
        <div class="modal-content" >
          <div class="modal-header">         
            <span class="modal-title">{{head_title}}</span>
            <!-- <span class="modal-title">{{value}}</span> -->
            <span aria-hidden="true" class="modal-span" @click="close">&times;</span>  
          </div>
          <div class="modal-body" @scroll="table_cont">
            <!-- Table -->
            <table class="table table-hover text-nowrap" >
                <thead class="th" :style="{transform:'translateY('+tans_late+'px)'}">
                  <tr>
                    <th v-for="(item,index) in heade_data" :key="index">{{item}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list,index) in list_data" :key="index" @click="col_radio(list.fld_record_id)"> 
                    <td v-for="(child_list,child_index) in show_data" :key="child_index">{{list[child_list]}}</td>
                    <td><input type="radio" v-model="list_radio" :value="list.fld_record_id"></td> 
                  </tr>
                </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default btn-default-close" data-dismiss="modal" @click="cancel_selection">{{cancel}}</button>
            <button type="button" class="btn btn-default-determine" @click="determine">{{confirm}}</button>
          </div>
          <!-- 加载状态 -->
          <div class="loading" v-if="anate"><i class="fa fa-spin fa-spinner"></i></div>
        </div>
      </div>
    </div>
     <!-- 提示组件 -->
	<tips v-if="sel_tips" :current_state="current_state" :language_pack="language_pack"></tips>
  </transition>
</template>
<script>
  import { mapState } from 'vuex';
  import api from "../api/index.js";
  import tips from "./tips.vue"
  export default {
    name: 'Project',
    components: {
      tips
    },
    computed:{
      head_title(){
        return '--'+this.$attrs.language_pack[this.sel_language].select_distribution_package+'--'
      },
      confirm(){
        return this.$attrs.language_pack[this.sel_language].confirm
      },
      cancel(){
        return this.$attrs.language_pack[this.sel_language].cancel
      },
      ...mapState({
        sel_language:'sel_language'
      })
    },
    data(){
      return {
        //错误提是信息
        current_state:'',
        //是否显示提是组件
        sel_tips:false,
        //距离头部的位置
        tans_late:'',
        //加载状态
        anate:true,
        //复选框的数组
        check_data:[],
        //获取的弹框数据
        list_data:null,
        //单选按钮
        list_radio:'',
        //头部数据
        show_data:null,
        //计数
        // count:0,
        heade_data:[],
        rows:null,
        //标题
        value:'',
        //是否是ie
        is_ie:false
      }
    },
    mounted(){
    //获取数据
      this.get_data();
      //判断是不是ie
      this.t_ie()
    },
    props:[
      //有弹框的头部字段（根据此字段判断是否有弹框）
      'ppr_action',
      //有弹框的数据头部字段
      'ppr_action_param',
      //弹框中的函数
      'box_fun',
      //输入框中的值
      'rule_data'
    ],
    methods:{
      
      t_ie(){
        if (!!window.ActiveXObject || "ActiveXObject" in window) {
          // this.is_ie='translate(-50%, -50%)'
        }
      },
      //捕获异步错误
			async_error(promise){
				return promise.then(res => res).catch(error => this.error_message(error));
			},
      //错误提示
			error_message(message){
				this.sel_tips=true;
				this.current_state=message;
				window.setTimeout(()=>{
					this.sel_tips=false;
				},2000)
				this.anate=false;
			},
      //遍历显示字段
      display_field(rows,show_data){
        for(var i=0;i<show_data.length;i++){
          //遍历头部数据
          rows.forEach((item,index)=>{
            if(item.Name==this.show_data[i]){ 
              this.heade_data.push(item.Comment)
            }
          })
        }
      },
      //显示字段没有时显示undefind
      show_no(data,show_data){
        show_data.forEach((item,index)=>{
              data.forEach((ite,i)=>{
                if(ite.fld_record_id==undefined){
                  ite.fld_record_id=i
                };
                if(ite[item]==undefined){
                  ite[item]='undefined'
                }
              })
        })
      },
      //有值的时候把对应的数据项选中
      selected_data(){
        if(this.rule_data!=undefined&&this.ppr_action=="selecttion_typeid"){
              this.list_radio=this.rule_data;
              this.list_data.forEach((item,index)=>{
                if(item.fld_short_name){
                  if(this.rule_data==item.fld_short_name){
                    this.list_radio=item.fld_record_id
                  };
                };               
              })
            }
            if(this.rule_data!=undefined&&this.ppr_action=="LanguageChoice"){
               this.list_radio=this.rule_data;
              
              this.list_data.forEach((item,index)=>{
                if(item.fld_lang){
                  if(this.rule_data==item.fld_lang){
                    this.list_radio=item.fld_record_id
                  };
                };               
              })
            }
      },
      //获取数据
      async get_data(){
        //自动请求根据action的数据接口返回需要的页面数据          
          let res1=await this.async_error(api.getChoiceAppHead(this.box_fun.ACTION_COLUMNS_URL))
          //返回的头部数据
          this.rows=res1.data.FIELDS;
          if(res1.data.error==-1){
              this.error_message(res.data.message)
							return false
          }
          //根据action请求数据，在利用前一个接口字段返回需要的接口数据    
          if(this.ppr_action=="selecttion_typeid"||this.ppr_action=="LanguageChoice"){
            let res=await this.async_error(api.getChoiceAppRows(this.box_fun.ACTION_DATA_URL,'?userInfo='+window.sessionStorage.getItem('userInfo')))
            //获取显示字段的数组
            this.show_data=this.box_fun.ACTION_SHOW_FIELDS;
            console.log(this.show_data)
            //遍历显示字段
            this.display_field(this.rows,this.show_data)
            this.heade_data.push('选择');
            //当显示的字段没有时显示undefind
            this.show_no(res.data,this.show_data);
            this.list_data=res.data.reverse();
            this.anate=false;
            //有值的时候选中某一项
            this.selected_data()
          } 
          else{
            let res=await this.async_error(api.getChoiceAppRows(this.box_fun.ACTION_DATA_URL,'?fld_type_id='+this.ppr_action_param+'&userInfo='+window.sessionStorage.getItem('userInfo')))
              //获取显示字段的数组  
              this.show_data=this.box_fun.ACTION_SHOW_FIELDS;
              //遍历显示字段
              this.display_field(this.rows,this.show_data)
              this.heade_data.push('选择');
              this.show_no(res.data,this.show_data);
              this.list_data=res.data.reverse();
              this.anate=false;
              if(this.rule_data!=undefined){
                // alert(1)
                // console.log(this.rule_data)
                this.list_radio=this.rule_data;
                // console.log(this.list_data)
                this.list_data.forEach((item,index)=>{
                  if(item.fld_short_name){
                    if(this.rule_data==item.fld_short_name){
                      this.list_radio=item.fld_record_id
                    }
                  };
                  if(item.fld_group_id){
                    if(this.rule_data==item.fld_group_id){
                      this.list_radio=item.fld_record_id
                    }
                  };
                  if(item.fld_value){
                    if(this.rule_data==item.fld_value){
                      this.list_radio=item.fld_record_id
                    }
                  }
                })
              }
          }  
      },
      //固定表头
      table_cont(e){
				this.tans_late=e.target.scrollTop;
		  },
      //点击tr元素选中radio标签
      col_radio(i){
        this.list_radio=i;
      },
      //点击关闭图标
      close(){
        this.$emit('close_project')
      },
      //点击取消
      cancel_selection(){
        this.list_radio='';
      },
      //点击确定
      determine(){
        var data='';
        this.list_data.forEach((item)=>{
          if(item.fld_record_id==this.list_radio){
            if(item.fld_short_name){
              data=item.fld_short_name
            };
            if(item.fld_group_id){
              data=item.fld_group_id
            };
            if(item.fld_value){
              data=item.fld_value
            }
            // if(item.fld_lang){
            //   data=item.fld_lang
            // }
            // console.log(data)
          }
        })
        this.$emit('input_data',data) 
        },
    },
    directives: {
      drag: {
        inserted(el) {
          let drag_Box = el; //获取当前元素
          let dragBox = document.getElementsByClassName('modal-header')[0];
          dragBox.onmousedown = e => {
              //算出鼠标相对元素的位置
              let disX = e.clientX - drag_Box.offsetLeft;
              let disY = e.clientY - drag_Box.offsetTop;
              document.onmousemove = e => {
                console.log(1)
                  //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                  let left = e.clientX - disX;
                  let top = e.clientY - disY;
                  //移动当前元素
                  drag_Box.style.left = left + "px";
                  drag_Box.style.top = top + "px";
              };
              document.onmouseup = e => {
                    //鼠标弹起来的时候不再移动
                    document.onmousemove = null;
                   //预防鼠标弹起来后还会循环（即预防鼠标放上去的时候还会移动）  
                  document.onmouseup = null;
              };
          };
        }
      }
    }
  }
</script>
<style scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .th{
    background: white;
  }
  .fa-spin{
	    -webkit-animation: fa-spin 1s infinite linear;
      animation: fa-spin 1s infinite linear;
	}
  .modal-footer{
    justify-content: space-between;
  }
	.loading{
		z-index: 1000;
		font-size: 50px;
		position: absolute;
		color: rgb(138, 132, 132);
		top: 50%;
		left: 50%;
		/* transform: translate(-50%, -50%); */
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px));
		text-align: center;
	}
  .modal-header{
    cursor: move;
  }
  .modal-body{
    max-height: 500px;
    overflow: auto;
    padding-top: 0;
  }
  .table>tbody>tr>td {
    text-align: center;
  }
  .table>thead>tr>th {
    text-align: center;
  }
	.project{
    min-width: 846px;
    position: fixed;
    top: 50%;
    left: 50%;
    height: 500px;
    z-index:999;
    transform: translate(-50%, -50%);
    overflow: visible;
	  bottom: inherit;
	  right: inherit;
	  /* transform: translate(calc(-50% + 0.5px), calc(-50% + 0.5px)); */
  }
 .modal-header{
		background:#ebecf0;
		height:40px
	}
 .modal-span{
		font-size:20px;
		margin-top:-14px;
		cursor:pointer
	}
	.modal-title{
		line-height:1px
	}
  .btn-default-close{
    color:#007bff;
		font-size:12px;
		border:1px solid #808080;
		padding:4px;
		/* margin-right: 90%; */
  }
  .btn-default-determine{
    color:#007bff;
		font-size:12px;
		border: 1px solid rgb(128, 128, 128);
		padding: 4px;
  }
  td{
    font-size: 12px;
  }
</style>